import { jsx } from "react/jsx-runtime";
import { CheckboxFieldWUT } from "../../../ui/checkbox-field/checkbox-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const CheckboxWUT = (props) => {
  const fieldType = FIELD_TYPES.CHECKBOX;
  return /* @__PURE__ */ jsx(CheckboxFieldWUT, { ...props, fieldType });
};
export {
  CheckboxWUT
};
//# sourceMappingURL=checkbox-wut.js.map
